<!-- Button -->
<button
  mat-icon-button
  class="user-button"
  [matMenuTriggerFor]="userActions"
  [attr.aria-label]="'Conta de ' + (user?.name || user?.email || '')">
  @if (showAvatar && user?.avatar) {
    <img
      class="user-button__avatar"
      [src]="user.avatar"
      alt="">
  } @else {
    <span class="user-button__initials">{{ initials }}</span>
  }
</button>

<mat-menu
  [xPosition]="'before'"
  class="user-menu"
  #userActions="matMenu">
  <div class="user-menu__identity" (click)="$event.stopPropagation()">
    <span class="user-menu__name">{{ user?.name }}</span>
    <span class="user-menu__email">{{ user?.email }}</span>
  </div>
  <mat-divider></mat-divider>
  <button
    mat-menu-item
    (click)="signOut()">
    <mat-icon [svgIcon]="'heroicons_outline:logout'"></mat-icon>
    <span>Terminar sessão</span>
  </button>
</mat-menu>
